import _asyncToGenerator from "/Users/eyalbarta/Projects/mb-portal-fe-quasar/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js";
import _regeneratorRuntime from "/Users/eyalbarta/Projects/mb-portal-fe-quasar/node_modules/@babel/runtime-corejs2/regenerator/index.js";
import Api from "../../utils/api";
export function getHolidays(_x) {
  return _getHolidays.apply(this, arguments);
}
function _getHolidays() {
  _getHolidays = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref) {
    var state, commit, _yield$Api$get, data;
    return _regeneratorRuntime.wrap(function (_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          state = _ref.state, commit = _ref.commit;
          if (!state.holidays) {
            _context.next = 1;
            break;
          }
          return _context.abrupt("return", state.holidays);
        case 1:
          _context.next = 2;
          return Api().get('api/holidays');
        case 2:
          _yield$Api$get = _context.sent;
          data = _yield$Api$get.data;
          commit('holidays/setHolidays', data, {
            root: true
          });
        case 3:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return _getHolidays.apply(this, arguments);
}